import React from 'react';
import classNames from 'classnames';
import * as ReactDOM from 'react-dom';

import Loader from 'react-loader-spinner';
import { Header } from './Header';
import { Footer } from './Footer';
import { Categories } from './Categories';
import { Modals } from './Modals';
import { Jobs } from './Jobs';
import {
    createMapPathUrl,
    deleteCookie,
    getCookie,
    setCookie,
    showModal,
    updateMapPathUrl
} from '../common/utilities';
import $ from 'jquery';

export class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mapName: 'Career Map',
            // direction: '',
            categories : [],
            levels : [],
            jobs: [],
            curatedJobs : [],
            isCurated: false,
            isTraced: true,
            tracedJobs: props.tracedJobs ? props.tracedJobs : [],
            isFetching: true,
            isShowCollegeDegree: false,
            isShowSalary: true,
            enableWelcomeModal: false,
            welcomeModalData: null
        };

        this.reset = this.reset.bind(this);
        this.clearMap = this.clearMap.bind(this);

        this.getCuratedJobs = this.getCuratedJobs.bind(this);
        this.showCuratedJobs = this.showCuratedJobs.bind(this);

        this.getTracedJobs = this.getTracedJobs.bind(this);
        this.setTracedJobs = this.setTracedJobs.bind(this);

        this.isTraced = this.isTraced.bind(this);

        this.isCurated = this.isCurated.bind(this);
        this.setCurated = this.setCurated.bind(this);

        this.setSearch = this.setSearch.bind(this);
    }

    async componentDidMount() {
        const { id } = this.props;

        await fetch(`/wp-json/jls/v1/career-map/${id}`)
            .then(response => response.json())
            .then(mapData => {
                this.setState({
                    mapName: mapData.name,
                    categories : mapData.job_categories || [],
                    levels : mapData.job_levels || [],
                    curatedJobs : mapData.curated_paths || [],
                    headline: mapData.headline || 'Find your path from any to any job to advance or make a switch in your career.',
                    subHeadline: mapData.subheadline || '',
                    aboutThisMap: mapData.about_this_map || '',
                    direction: mapData.direction || '',
                    disclaimer: mapData.disclaimer || '',
                    disclaimerPosition: mapData.disclaimer_position || '',
                    disclaimerCollegeText: mapData.disclaimer_college_text || '',
                    disclaimerUnionText: mapData.disclaimer_union_text || '',
                    isShowSalary: mapData.show_salary_info,
                    enableWelcomeModal: mapData.enable_video_modal,
                    welcomeModalData: mapData.video_modal,
                })
            })
            .catch(error => {
                console.log('Map fetching failed.');
                console.log(error.message);
                console.trace();
            });

        await fetch(`/wp-json/jls/v1/career-map/${id}/jobs`)
            .then(response => response.json())
            .then(response => {
                this.setState({
                    jobs : response.jobs || [],
                    // answer on the 'Do you have a College Degree?' question from the form of which a user redirected here
                    isShowCollegeDegree: !response.college_degree_required,
                    isFetching: false,
                })
            })
            .catch(error => {
                console.log('Jobs fetching failed.');
                console.log(error.message);
                console.trace();
            });

        let docWidth = $(window).width(),
            docHeight = $(window).height();

        window.addEventListener('resize', () => {
            if ($(window).width() === docWidth && $(window).height() === docHeight) return;

            docWidth = $(window).width();
            docHeight = $(window).height();

            this.reset();

            this.setTracedJobs([]);

            if (this.state.isCurated) {
                this.showCuratedJobs();
            }
        });

        // Modals
        $(document).on('click', '.js-modal', function(event) {
            event.preventDefault();

            const modal = document.querySelector(this.getAttribute('href'));

            showModal(modal);
        });

        $(document).on('click', '.js-modal-close', function() {
            $(this).closest('.modal-outer-wrapper').find('.modal-body').scrollTop(0);

            $(this.closest('.modal-outer-wrapper')).fadeOut('fast', function() {
                document.body.style.paddingRight = '';
                document.body.classList.remove('modal-opened');
            });
        });

        $(document).on('click', '.modal-outer-wrapper', function(event){
            if($(event.target).hasClass('d-table-cell')) {
                $(this).fadeOut('fast', function() {
                    document.body.style.paddingRight = '';
                    document.body.classList.remove('modal-opened');
                });
            }
        });

        window.addEventListener('resize', () => {
            $('.modal-outer-wrapper:visible').css('height', window.innerHeight);
        });

        $(document).click((e) => {
            // close a job popup when click outside of a job node and a node is not connected to the other nodes
            let target = $(e.target);

            if(!target.closest('.job').length && this.getTracedJobs().length <= 1) {
                this.reset();
            }
        });

        this.handleWelcomeModal();
    }

    handleWelcomeModal() {
        const cookieName = 'jls-show-welcome-modal';

        if (this.state.enableWelcomeModal) {
            this.welcomeModalTimer = setTimeout(() => {
                const isShowModal = getCookie(cookieName) !== '0';

                if (isShowModal) {
                    const modalWelcome = document.querySelector('.modal-welcome');

                    if (modalWelcome) {
                        modalWelcome.style.display = 'block';
                    }

                    setCookie(cookieName, '0', 365); // Set the cookie to '0' for 1 year
                }
            }, 3000);
        } else {
            if (getCookie(cookieName)) {
                deleteCookie(cookieName);
            }
        }
    }

    componentWillUnmount() {
        if (this.welcomeModalTimer) {
            clearTimeout(this.welcomeModalTimer);
        }
    }

    isTraced() {
        return this.state.isTraced;
    }

    getTracedJobs() {
        return this.state.tracedJobs;
    }

    setTracedJobs(val) {
        this.setState({
            tracedJobs: val,
        }, () => {
            if (!this.state.isCurated) {
                updateMapPathUrl(createMapPathUrl(val));
            }
        });
    }

    setCurated(val) {
        this.setState({
            isCurated: val,
        }, () => {
            if (val) {
                updateMapPathUrl(createMapPathUrl([], null));
            }
        })
    }

    isCurated() {
        return this.state.isCurated;
    }

    getCuratedJobs() {
        return this.state.curatedJobs;
    }

    setSearch(val) {
        this.getSearchNode.val = val;
    }

    showCuratedJobs() {
        const { curatedJobs } = this.state;

        curatedJobs.forEach((job) => {
            if (job.jobs[0]) {
                const start = document.querySelector('.job:not(.fake)[data-id="' + job.jobs[0] + '"]');
                start.classList.add('is-selected');
                start.setAttribute('data-curated', job.id);
            }
        });
    }

    getSearchNode() {
        return document.getElementById('search');
    }

    getTraceNode() {
        return document.getElementById('trace');
    }

    //revert map back to the original state
    reset(isClearTracedJobs = true, isHighlightCuratedJobs = true) {
        const { tracedJobs, isCurated } = this.state;

        const mapNode = this.mapNode();

        if (mapNode) {
            this.clearMap();

            if (isCurated && isHighlightCuratedJobs) {
                this.showCuratedJobs();
            } else {
                mapNode.classList.remove('is-active');
            }
        }

        let url = createMapPathUrl(isCurated ? null : tracedJobs);

        if (isClearTracedJobs) {
            this.setState({
                tracedJobs: []
            });

            url = createMapPathUrl(null);
        }

        updateMapPathUrl(url);
    }

    clearMap() {
        const mapNode = this.mapNode();

        mapNode.querySelectorAll('.job').forEach(el => {
            el.classList.remove('hidden');
        });

        mapNode.querySelectorAll('.path-line, .job.fake').forEach(el => {
            el.style.opacity = 0;
            setTimeout(() => {
                el.remove();
            }, 100)
        });

        document.querySelectorAll('.job').forEach(job => {
            job.classList.remove('is-selected','is-active', 'is-hover', 'is-traced', 'show-description');
            job.removeAttribute('data-curated');
            job.removeAttribute('data-direction');
        });
    }

    mapNode() {
        return document.getElementById('careerMap');
    }

    render() {
        if (this.state.isFetching) {
            return (
                <div className="map-loader">
                    <Loader
                        type="Oval"
                        color="#cccccc"
                        height={50}
                        width={50}
                    />
                </div>
            )
        }

        const { isMixpanel } = this.props;
        const {
            mapName,
            jobs,
            isCurated,
            categories,
            direction,
            levels,
            isShowCollegeDegree,
            curatedJobs,
            headline,
            subHeadline,
            aboutThisMap,
            disclaimer,
            disclaimerPosition,
            disclaimerCollegeText,
            disclaimerUnionText,
            isShowSalary,
            enableWelcomeModal,
            welcomeModalData,
        } = this.state;

        return (
            <>
                <Header
                    mapName={mapName}
                    mapNode={this.mapNode}
                    jobs={jobs}
                    isCurated={this.isCurated}
                    reset={this.reset}
                    isTraced={this.isTraced}
                    clearMap={this.clearMap}
                    setCurated={this.setCurated}
                    showCuratedJobs={this.showCuratedJobs}
                    isMixpanel={isMixpanel}
                    getTracedJobs={this.getTracedJobs}
                    curatedJobs={curatedJobs}
                    headline={headline}
                    subHeadline={subHeadline}
                    aboutThisMap={aboutThisMap}
                    disclaimer={disclaimer}
                    disclaimerPosition={disclaimerPosition}
                    disclaimerCollegeText={disclaimerCollegeText}
                    disclaimerUnionText={disclaimerUnionText}
                />

                <div
                    id="careerMap"
                    className={classNames('map-container', {
                        'is-curated is-active': isCurated,
                    })}
                >
                    <div className="map-grid">
                        <Categories categories={categories} />

                        <Jobs
                            jobs={jobs}
                            categories={categories}
                            levels={levels}
                            isShowCollegeDegree={isShowCollegeDegree}
                            isShowSalary={isShowSalary}

                            reset={this.reset}
                            mapNode={this.mapNode}
                            traceNode={this.getTraceNode()}
                            searchNode={this.getSearchNode()}

                            getCuratedJobs={this.getCuratedJobs}

                            isTraced={this.isTraced}
                            isCurated={this.isCurated}

                            setTracedJobs={this.setTracedJobs}
                            getTracedJobs={this.getTracedJobs}

                            showCuratedJobs={this.showCuratedJobs}

                            setSearch={this.setSearch}
                            isMixpanel={isMixpanel}
                        />
                    </div>
                </div>

                <div className="d-flex justify-content-between mt-16">
                    <ul className="map-legends">

                        {
                            ( ( disclaimer == '' || disclaimer == 'both' || disclaimer == 'college' ) && (disclaimerPosition == '' || disclaimerPosition == 'bottom') ) && isShowCollegeDegree && (
                                <li className="map-legends__item">
                                    <span className="map-legends__icon"><span className="diamond-icon"/></span>
                                    <span className="map-legends__name">{disclaimerCollegeText || '4-year College Degree is Typically Required'}</span>
                                </li>
                            )
                        }

                        {
                            ( ( disclaimer == 'union' || disclaimer == 'both' ) && disclaimerPosition == 'bottom' ) && (
                                <li className="map-legends__item">
                                    <span className="map-legends__icon"><span className="union-icon"/></span>
                                    <span className="map-legends__name">{disclaimerUnionText || 'Union Membership is Common for This Position'}</span>
                                </li>
                            )
                        }
                                
                    </ul>

                    <div className="reset reset--footer">
                        <button className="reset__button" onClick={this.reset}>CLEAR MAP</button>
                    </div>
                </div>

                <Footer
                    jobs={jobs}
                    levels={levels}
                    isShowCollegeDegree={isShowCollegeDegree}
                    isShowSalary={isShowSalary}
                    isTraced={this.isTraced}
                    isCurated={this.isCurated}
                    getTracedJobs={this.getTracedJobs}
                    setTracedJobs={this.setTracedJobs}
                    categories={categories}
                    direction={direction}
                    isMixpanel={isMixpanel}
                />

                {
                    ReactDOM.createPortal(
                        <Modals
                            jobs={this.state.jobs}
                            categories={this.state.categories}
                            isShowCollegeDegree={isShowCollegeDegree}
                            isShowSalary={isShowSalary}
                        />,
                        document.querySelector('body')
                    )
                }

                {
                    ReactDOM.createPortal(
                        <div className="modal-outer-wrapper modal-base modal-need-rebuild-path" id="need-rebuild-path">
                            <div className="modal-inner-wrapper d-table">
                                <div className="d-table-cell">
                                    <div className="modal">
                                        <div className="container">
                                            <button className="modal-close js-modal-close"><span className="show-for-sr">Close modal</span>
                                            </button>
                                            <h2 className="modal-base__title">The map has changed and one or more of your saved jobs is no longer available. Please rebuild your career map.</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>,
                        document.querySelector('body')
                    )
                }

                {
                    enableWelcomeModal ? (
                        ReactDOM.createPortal(
                            <div
                                className="modal-outer-wrapper modal-welcome"
                                style={{
                                    '--h': 192,
                                    '--s': '100%',
                                    '--l': '18%',
                                }}
                            >
                                <div className="modal-inner-wrapper d-table">
                                    <div className="d-table-cell">
                                        <div className="modal">
                                            <header className="modal-header">
                                                <div className="container">
                                                    <button className="modal-close js-modal-close">
                                                        <span className="show-for-sr">Close modal</span>
                                                    </button>
                                                </div>
                                            </header>

                                            <div className="modal-body">
                                                <div className="modal-top">
                                                    <div className="container" >
                                                        <div className="modal-description">
                                                            <h2
                                                                className="modal-welcome__title"
                                                                dangerouslySetInnerHTML={{ __html: welcomeModalData.headline }}
                                                            />

                                                            <div
                                                                className="modal-video-wrapper"
                                                                dangerouslySetInnerHTML={{ __html: welcomeModalData.video }}
                                                            />

                                                            <button
                                                                type="button"
                                                                className="modal-welcome__btn js-modal-close"
                                                            >Got it</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>,
                            document.querySelector('body')
                        )
                    ) : null
                }
            </>
        );
    }
}

